import {
  TbArrowsLeftRight,
  TbArrowDown,
  TbCoins,
  TbFileText,
  TbTransfer,
  TbWorldDollar,
} from "react-icons/tb";
import intl from "react-intl-universal";
import { ShortcutCard } from "../../../../Components/Atoms/ShortcutCard";
import { useAuth } from "../../../../Contexts/AuthContext";
import { STABLES_HOME_PATH } from "../../Stables/constants";
import { useIbProductFeaturesStore } from "../../../../Stores/ibProductFeaturesStore";
import { isIbProductEnabled } from "../../../../Utils/ibProductFeatures";
import { CROSSBORDER_HOME_PATH } from "../../Crossborder/constants";

export const ContaInternacionalShortcutMenu = ({
  onOpenDados,
  onOpenDepositar,
  onOpenMovimentar,
  onOpenTransferir,
}) => {
  const { hasPermission } = useAuth();
  const canTransfer = hasPermission("internationaltransfer");
  const features = useIbProductFeaturesStore((state) => state.features);

  const items = [
    ...(onOpenDados
      ? [
          {
            id: "dados",
            label: intl.get("profile.data"),
            icon: TbFileText,
            onClick: onOpenDados,
          },
        ]
      : []),
    {
      id: "deposit",
      label: intl.get("contaInternacional.deposit"),
      icon: TbArrowDown,
      onClick: onOpenDepositar,
    },
    ...(canTransfer
      ? [
          {
            id: "moviment",
            label: intl.get("contaInternacional.moviment"),
            icon: TbArrowsLeftRight,
            onClick: onOpenMovimentar,
          },
          {
            id: "transfer",
            label: intl.get("contaInternacional.transfer"),
            icon: TbTransfer,
            onClick: onOpenTransferir,
          },
        ]
      : []),
    {
      id: "stables",
      label: intl.get("nav.stables"),
      icon: TbCoins,
      path: STABLES_HOME_PATH,
      permission: "stablesview",
      requiredFeature: "stables",
    },
    {
      id: "crossborder",
      label: intl.get("crossborder.title"),
      icon: TbWorldDollar,
      path: CROSSBORDER_HOME_PATH,
    },
  ];

  const visible = items.filter((item) => {
    if (item.permission && !hasPermission(item.permission)) return false;
    if (item.requiredFeature && !isIbProductEnabled(features, item.requiredFeature)) {
      return false;
    }
    if (item.onClick) return typeof item.onClick === "function";
    return Boolean(item.path);
  });

  return (
    <section className="mb-5 min-w-0 overflow-hidden">
      <h2 className="mb-3 text-sm font-bold text-brand-dark">
        {intl.get("contaInternacional.quickActions")}
      </h2>
      <div className="shortcut-scroll-row">
        {visible.map(({ id, label, icon, path, search, onClick }) => (
          <ShortcutCard
            key={id}
            to={path}
            search={search}
            onClick={onClick}
            icon={icon}
            label={label}
          />
        ))}
      </div>
    </section>
  );
};
